import { Component, OnInit } from '@angular/core';
import { EventService } from '../../../../../../store/services/event.service';

export interface IRedNoMatchContactSelectionEvent {
  contactId: number;
  defaultSelected: boolean;
}

export const RED_NO_MATCH_EVENT_NAME = 'red-no-match-contact-selected';

@Component({
  selector: 'app-contact-selector-actions',
  templateUrl: './contact-selector-actions.component.html',
  styleUrls: ['./contact-selector-actions.component.scss'],
})
export class ContactSelectorActionsComponent implements OnInit {
  defaultSelected: boolean;

  contactId: number;

  constructor(private readonly eventService: EventService) {
  }

  ngOnInit(): void {
  }

  onButtonClick() {
    this.eventService.broadcast<IRedNoMatchContactSelectionEvent>(
      RED_NO_MATCH_EVENT_NAME,
      {
        contactId: this.contactId,
        defaultSelected: this.defaultSelected,
      },
    );
  }
}
